<template>
  <v-btn
    elevation="0"
    class="zoox-component zoox-btn"
    :class="{small: buttonSize.small, rounded}"
    :rounded="rounded"
    :fab="!text"
    :small="buttonSize.small"
    :medium="buttonSize.medium"
    :large="buttonSize.large"
    :color="buttonStyle.color"
    :dark="buttonStyle.dark"
    :outlined="buttonStyle.outlined"
    :disabled="disabled"
    :loading="isLoading"
    :text="removeBg"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon v-if="icon && !iconRight" :class="{'mr-1': !rounded}">{{
      icon
    }}</v-icon>
    <!--@slot Slot para customização do texto do botão -->
    <slot name="text">
      <span
        v-if="text"
        class="zoox-btn-text button-text"
        :class="{'zoox-rounded-btn-text': rounded}"
        v-html="text"
      >
      </span>
    </slot>
    <v-icon v-if="icon && iconRight" :class="{'ml-1': !rounded}">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
/**
 * Botão principal da aplicação. Utilizado para fazer ações
 * dentro do sistema, sendo elas primárias, secundárias ou qualquer outro tipo de ação.
 *
 * @displayName Button
 */
export default {
  name: 'ZBtn',
  props: {
    /**
     * Texto do botão
     */
    text: {
      type: String,
      required: false,
    },
    /**
     * Flag para deixar o botão arredondado
     */
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Ícone para ser usado no botão
     */
    icon: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Indicação da cor do botão
     */
    color: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Flag para indicar que é um botão primário (fica preenchido com background primário)
     */
    primary: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que é um botão de confirmação
     */
    confirmation: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o conteúdo com cor branca
     */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para desabilitar o botão
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão em modo loading
     */
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o ícone passado na direito
     */
    iconRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão grande (default no mobile)
     */
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão pequeno
     */
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão medio (default no desktop)
     */
    medium: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Remove o background do botão (text)
     */
    removeBg: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    buttonSize() {
      const isMobile = this.$vuetify.breakpoint.mobile

      if (isMobile) {
        return {
          large: !this.medium && !this.small,
          medium: this.medium,
          small: this.small,
        }
      } else {
        return {
          large: this.large,
          medium: !this.large && !this.small,
          small: this.small,
        }
      }
    },

    buttonStyle() {
      if (this.color) {
        return {
          outlined: !this.primary,
          color: this.color,
          dark: this.dark || false,
        }
      }

      if (this.confirmation) {
        return {
          dark: !this.disabled,
          color: 'success',
          outlined: false,
        }
      } else if (this.primary) {
        return {
          dark: !this.disabled,
          color: 'primary',
          outlined: false,
        }
      }
      return {
        dark: false,
        color: 'primary',
        outlined: true,
      }
    },
  },
  methods: {
    onClick() {
      /**
       * Emitido quando o botão é clicado
       */
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-btn {
  border-radius: var(--zoox-btn-radius);

  &.small {
    border-radius: var(--component-button-sm-radius);
    height: 30px !important;
  }

  &.rounded {
    border-radius: var(--semantic-radius-rounded) !important;
  }
}

.zoox-btn-text {
  text-align: start;
  color: unset;
}

.zoox-rounded-btn-text {
  margin-right: var(--component-button-md-gap);
  margin-left: var(--component-button-md-gap);
}
</style>
